import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ArrowUpOutlined } from '@ant-design/icons';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import { useTheme } from '../../context/ThemeContext';
import './Layout.less';

const Layout: React.FC = () => {
  const { theme } = useTheme();
  const [showBackToTop, setShowBackToTop] = useState(false);
  
  // 将背景颜色应用到body元素
  useEffect(() => {
    if (theme === 'dark') {
      document.body.style.backgroundColor = '#000000';
      document.body.style.color = '#ffffff';
    } else {
      document.body.style.backgroundColor = '#ffffff';
      document.body.style.color = '#000000';
    }
  }, [theme]);
  
  // 监听滚动事件以显示/隐藏回到顶部按钮
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // 回到顶部
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <div className={`app-layout theme-${theme}`}>
      <Nav />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      
      {/* 回到顶部按钮 */}
      {showBackToTop && (
        <button 
          className="back-to-top-btn" 
          onClick={scrollToTop}
          aria-label="回到顶部"
        >
          <ArrowUpOutlined />
        </button>
      )}
    </div>
  );
};

export default Layout;